import { service } from '../../helpers/http'

export default {
  actions: {
    ActionAmbienceAllocationRulesIndex: ({ commit }, payload) => {
      const p = { ...(payload || {}) }
      if (p.search != null && String(p.search).trim() !== '') {
        p.q = p.search
      }
      delete p.search
      delete p.column_order
      delete p.direction

      return service({
        module: 'ambienceAllocationRules',
        action: 'index',
        payload: p,
      })
    },

    ActionAmbienceAllocationRulesDuplicate: ({ commit }, payload) =>
      service({
        module: 'ambienceAllocationRules',
        action: 'duplicate',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAmbienceAllocationRulesToggle: ({ commit }, payload) => {
      const body = {}
      if (Object.prototype.hasOwnProperty.call(payload || {}, 'active')) {
        body.active = payload.active
      }
      return service({
        module: 'ambienceAllocationRules',
        action: 'toggle',
        params: { id: payload.id },
        payload: body,
      })
    },

    ActionAmbienceAllocationRulesDestroy: ({ commit }, payload) =>
      service({
        module: 'ambienceAllocationRules',
        action: 'destroy',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAmbienceAllocationRulesShow: ({ commit }, payload) =>
      service({
        module: 'ambienceAllocationRules',
        action: 'show',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAmbienceAllocationRulesStore: ({ commit }, payload) =>
      service({
        module: 'ambienceAllocationRules',
        action: 'store',
        payload,
      }),

    ActionAmbienceAllocationRulesUpdate: ({ commit }, payload) =>
      service({
        module: 'ambienceAllocationRules',
        action: 'update',
        params: { id: payload.id },
        payload,
      }),
  },
  namespaced: true,
}
